import { Features } from "store/environments/tenants/tenant-configurations/tenant-configurations-types";

import { TenantFeatureSettingWorkFlowType } from "utils/tenant-workflows/tenant-workflows-types";

export const featureSettings: Map<
    keyof Features,
    TenantFeatureSettingWorkFlowType
> = new Map<keyof Features, TenantFeatureSettingWorkFlowType>([
    [
        "vectorVendorRecognitionEnabled",
        TenantFeatureSettingWorkFlowType.SimilarityVendorRecognition,
    ],
]);
